import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const Help = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <path
        d="M6.99973 6.00149C7.11719 5.66757 7.34906 5.386 7.65426 5.20665C7.95939 5.0273 8.31819 4.96173 8.66706 5.02158C9.01599 5.08142 9.33239 5.26281 9.56039 5.53361C9.78833 5.80441 9.91313 6.14715 9.91259 6.50112C9.91259 7.5004 8.41366 8 8.41366 8M8.43299 10H8.43966M8.33306 13.3333C11.4627 13.3333 13.9997 10.7963 13.9997 7.66667C13.9997 4.53705 11.4627 2 8.33306 2C5.20346 2 2.66641 4.53705 2.66641 7.66667C2.66641 8.3 2.77031 8.90907 2.96199 9.47773C3.03412 9.69173 3.07019 9.79873 3.07669 9.88093C3.08312 9.96213 3.07826 10.0191 3.05818 10.0979C3.03784 10.1779 2.99294 10.261 2.90314 10.4272L1.8127 12.4456C1.65716 12.7335 1.57939 12.8774 1.59679 12.9885C1.61195 13.0853 1.66891 13.1705 1.75253 13.2215C1.84853 13.2801 2.01127 13.2632 2.33677 13.2296L5.75079 12.8767C5.85417 12.866 5.90587 12.8607 5.95299 12.8625C5.99933 12.8642 6.03204 12.8686 6.07723 12.879C6.12318 12.8896 6.18096 12.9119 6.29651 12.9563C6.92853 13.1999 7.61519 13.3333 8.33306 13.3333Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default withStyles(Help);
